import { configureHttpClient } from '@equinor/fusion-framework-module-http';
import { BaseModuleProvider } from '@equinor/fusion-framework-module/provider';
import { version } from './version';
/**
 * Default implementation of {@link IServiceDiscoveryProvider}.
 *
 * Created during module initialization and delegates service resolution to
 * the underlying {@link IServiceDiscoveryClient} while using the
 * {@link HttpModule} to construct pre-configured HTTP clients.
 */
export class ServiceDiscoveryProvider extends BaseModuleProvider {
    config;
    _http;
    /**
     * @param config - Resolved service discovery configuration.
     * @param _http - HTTP module instance used to create clients.
     */
    constructor(config, _http) {
        super({
            version,
            config,
        });
        this.config = config;
        this._http = _http;
    }
    /** {@inheritDoc IServiceDiscoveryProvider.client} */
    get client() {
        return this.config.discoveryClient;
    }
    /** {@inheritDoc IServiceDiscoveryProvider.resolveServices} */
    resolveServices() {
        return this.config.discoveryClient.resolveServices();
    }
    /** {@inheritDoc IServiceDiscoveryProvider.resolveService} */
    async resolveService(key) {
        return this.config.discoveryClient.resolveService(key);
    }
    /** {@inheritDoc IServiceDiscoveryProvider.createClient} */
    async createClient(name, opt) {
        const service = await this.resolveService(name);
        // A missing service configuration means the http client can't be constructed
        if (!service) {
            throw Error(`Could not load configuration of service [${name}]`);
        }
        return this._http.createClient({
            ...opt,
            baseUri: service.uri,
            defaultScopes: service.scopes,
        });
    }
    /** {@inheritDoc IServiceDiscoveryProvider.configureClient} */
    async configureClient(serviceName, config) {
        const { key, alias } = typeof serviceName === 'string' ? { key: serviceName, alias: serviceName } : serviceName;
        const { uri: baseUri, scopes: defaultScopes } = await this.resolveService(key);
        config.addConfig(configureHttpClient(alias, { baseUri, defaultScopes }));
    }
}
//# sourceMappingURL=provider.js.map